import {SafeAreaProvider} from 'react-native-safe-area-context';

import React, {useMemo} from 'react';

import {LogBox, Platform} from 'react-native';

LogBox.ignoreAllLogs(); //Hide all warning notifications on front-end

import AppComponent from './components/app';

import {UserData} from './api';

import {UserCtx, UserDataDispatch, UserDataState} from './ctx';

import {useUserData} from './hooks/useUserData';

import {
  configureFonts,
  MD3DarkTheme,
  PaperProvider,
} from 'react-native-paper';

const theme = {
  ...MD3DarkTheme,
  fonts: configureFonts({
    config: {
      default: {
        fontFamily: Platform.select({
          web: 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
          ios: 'System',
          macos: 'System',
          default: 'System',
        }),
        fontWeight: '400',
        letterSpacing: 0.5,
        lineHeight: 22,
        fontSize: 20,
      },
    },
    isV3: true,
  }),
};
import {store} from './store/store';
import {Provider} from 'react-redux';

import {QueryClientProvider} from 'react-query';

import {queryClient} from './api';
const App = () => {
  const {userDataState, userDataDispatch} = useUserData();
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <UserCtx.Provider value={UserData}>
          <UserDataState.Provider value={userDataState}>
            <UserDataDispatch.Provider value={userDataDispatch}>
              <SafeAreaProvider>
                <PaperProvider theme={theme}>
                  <React.Fragment>
                    {Platform.OS === 'web' ? (
                      <style type="text/css">{`
                    @font-face {
                      font-family: 'MaterialCommunityIcons';
                      src: url(${require('@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf')}) format('truetype');
                    }
                  `}</style>
                    ) : null}
                    <></>
                  </React.Fragment>
                  <AppComponent />
                </PaperProvider>
              </SafeAreaProvider>
            </UserDataDispatch.Provider>
          </UserDataState.Provider>
        </UserCtx.Provider>
      </QueryClientProvider>
    </Provider>
  );
};

export default App;
